<div class="block-html" [innerHTML]="block.data.content"></div>
